import { computed, defineComponent, h, ref, render, VNode, watch } from "vue";
import { useRoute } from "vue-router";
import { getPDFImage } from "../../api/document";
import { NodeOptions, Page, VisualAnnotation } from "../../models";
import {
  HomeOutlined,
  SearchOutlined,
  PartitionOutlined,
  CheckCircleOutlined,
  NodeIndexOutlined,
  FileSearchOutlined,
  SlidersOutlined,
  CalculatorOutlined,
  SecurityScanOutlined,
  ExpandOutlined,
  PlusCircleOutlined,
  ArrowLeftOutlined,
  LockOutlined,
  FolderOpenOutlined,
  ToolOutlined,
  LoadingOutlined,
  ClockCircleOutlined,
  StopOutlined,
  CheckOutlined,
  AuditOutlined,
  AudioOutlined,
  CommentOutlined,
} from "@ant-design/icons-vue";
import type { CustomIconName, iconName } from "../../utils/constants/icons";
import OCRIcon from "./OCR.vue";
import NetzbeweisIcon from "./Netzbeweis.vue";

import CookieOutlined from "./Cookie.vue";
export const DynamicIcon = defineComponent({
  name: "DynamicIcon",
  props: {
    type: {
      Type: {} as iconName,
      required: true,
      default: () => "AccountBookFilled" as iconName,
    },
  },
  components: {
    OCRIcon,
  },
  setup(props) {
    const renderedIcon = computed(() => {
      switch (props.type) {
        case "HomeOutlined":
          return () => <HomeOutlined />;
        case "SearchOutlined":
          return () => <SearchOutlined />;
        case "CheckCircleOutlined":
          return () => <CheckCircleOutlined />;
        case "CalculatorOutlined":
          return () => <CalculatorOutlined />;
        case "PartitionOutlined":
          return () => <PartitionOutlined />;
        case "OCRIcon":
          return () => <OCRIcon />;
        case "NetzbeweisIcon":
          return () => <NetzbeweisIcon />;
        case "NodeIndexOutlined":
          return () => <NodeIndexOutlined />;
        case "FileSearchOutlined":
          return () => <FileSearchOutlined />;
        case "SlidersOutlined":
          return () => <SlidersOutlined />;
        case "ExpandOutlined":
          return () => <ExpandOutlined />;
        case "LockOutlined":
          return () => <LockOutlined />;
        case "CookieOutlined":
          return () => <CookieOutlined />;
        case "ArrowLeftOutlined":
          return () => <ArrowLeftOutlined />;
        case "FolderOpenOutlined":
          return () => <FolderOpenOutlined />;
        case "PlusCircleOutlined":
          return () => <PlusCircleOutlined />;
        case "ToolOutlined":
          return () => <ToolOutlined />;
        case "LoadingOutlined":
          return () => <LoadingOutlined />;
        case "ClockCircleOutlined":
          return () => <ClockCircleOutlined />;
        case "StopOutlined":
          return () => <StopOutlined />;
        case "CheckOutlined":
          return () => <CheckOutlined />;
        case "AudioOutlined":
          return () => <AudioOutlined />;
        case "CommentOutlined":
          return () => <CommentOutlined />;
        case "AuditOutlined":
          return () => <AuditOutlined />;
        default:
          return () => <span></span>;
      }
    });
    return () => h(renderedIcon.value);
  },
});
